import { useImpuestoEmpresa } from "api/ImpuestoEmpresa.hook"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { useLocation } from "react-router-dom"
import FormCreacionDocumento from "../FormCreacionDocumento/FormCreacionDocumento"
import { TYPES_DOCUMENTOS } from "../FormCreacionDocumento/constant"

// TODO: selectores a eliminar tras la migracion: newDocumento, newDocumentoSelectorDoc, newDocumentoSelector, albaranLogisticoSelector, globalSelector

const CreacionAlbaran = () => {
  const { state } = useLocation()
  const downloadFile = useDownloadFileContext()
  const { activeCompany } = useUsuarioEmpresaActiva()
  const { usuarioByCurrent } = useUsuarioByCurrent()
  const empresaActiva = usuarioByCurrent?.empresaActiva

  const { impuestoEmpresa: tipoImpuestos } = useImpuestoEmpresa()

  const fieldValue = {
    id: activeCompany.id,
    logo: activeCompany.logo,
    logoAsBase64: activeCompany.logoAsBase64,
    ...(empresaActiva && { ...empresaActiva }),
  }

  return (
    <FormCreacionDocumento
      type={TYPES_DOCUMENTOS.ALBARAN}
      empresaActiva={fieldValue}
      // @ts-expect-error TS(2322): Type '{ type: string; empresaActiva: { id: string ...
      downloadFile={downloadFile}
      documento={state ?? null}
      tipoImpuestos={tipoImpuestos}
    />
  )
}

export default CreacionAlbaran
